export const phrases = {
  heading_settings_sort: "Sorting the employee list",
  body_settings_sort: "Sort employee list by first or last name.",
  since_o_clock: "Since {time}",
  old_data_warning_my_area: "We could not load any new information. Make sure you are connected to the Internet.",
  no_data_warning_my_area: "Make sure you are connected to the Internet and try again.",
  no_data_available_my_area: "No data can be loaded",
  last_update_data: "Last updated",
  something_went_wrong_absences: "Something went wrong. Please try again at a later time.",
  something_went_wrong_with_the_pin_entry: "Something went wrong with the PIN entry...",
  pin_must_be_four_digits: "The PIN must consist of exactly four digits.",
  pins_do_not_match: "The PINs entered do not match.",
  pin_is_not_numerical: "The PIN may only consist of numbers.",
  /** Phrasen für Task.getTechnicalNameFinish
   * -> müssen vermutlich irgendwann nochmal bearbeitet werden
   * z.B. 'Projekt beenden' macht eventuell keinen Sinn, wenn man das Projekt nicht beendet,
   * sondern nur die Arbeitszeit, die man auf dieses Projekt stempelt ?
   */
  finish_work_time: "Clock out",
  finish_break: "Finish the break",
  finish_loading_time: "End loading time",
  finish_driving_time: "End driving time",
  finish_business_trip: "Finish business trip",
  finish_project_as_task: "Finish project",
  finish_special_one: "Finish special1",
  finish_special_two: "Finish special2",
  you_clockout: "You are clocking out",
  sentence_work_time: "You are working. | You are working right now.",
  sentence_break: "You are taking a break. | You are taking a break.",
  sentence_loading_time: "You just captured load time. Hauruck! | You are capturing load time. Hauruck!",
  sentence_business_trip: "You are capturing a short business trip.",
  sentence_driving_time: "You're booking drive time. Buckle up and go! | You are booking travel time. Buckle up and go!",
  sentence_special_one: "You are booking special 1. | You are booking special1.",
  sentence_special_two: "You are booking special 2. | You are booking special2.",
  sentence_custom_time: "You are booking | You are booking",
  you_are_booked_in_activity: "Now clocking: {activity}! | Now clocking: {activity}!",
  substitute_warning: "A deputy must be named for absences of { days } days or more.",
  substituted_by: "Represented by",
  name_clocked_in: "{name} clocked in",
  /************************************/
  //Signature stuff:

  signature: "Signature",
  please_sign: "Please sign",
  signature_with_date: "Signature from {date}",
  signature_with_date_with_name: "Signature of {date} from {name}",
  signature_with_date_with_location: "Signature from {date} in {location}",
  signature_with_date_with_name_with_location: "Signature of {date} from {name} in {location}",
  signature_with_name: "Signature of {name}",
  signature_with_name_with_location: "Signature of {name} in {location}",
  signature_with_location: "Signature in {location}",
  /*************************************/

  accept_terms_and_conditions: "By sending the form you accept our {agb} and our {datenschutzerklaerung}.",
  what_is_your_name: "What is your name?",
  your_email: "Your email address",
  what_is_your_company_name: "What is the name of your company?",
  what_do_you_want_to_do_with_clockin: "What do you want to do with clockin?",
  almost_finished: "Almost done",
  test_clockin_for_amount_period: "Try clockin {amountOfDaysTestPeriod} for free!",
  code_needed_to_connect: "Use your code",
  you_have_no_company_code: "Don't have a code? Please refer to the respective contact person in your company.",
  connect_your_device: "Connect your device!",
  please_type_in_device_id: "Please enter the device ID, which you can find under mobile devices on our website.",
  new_at_clockin: "New to clockin?",
  pin_repeat: "Repeat PIN",
  configure_your_pin: "Set your 4-digit PIN",
  configure_your_pin_text: "You need the PIN to access your personal area on the tablet terminal.",
  congratulations: "Congratulations!",
  start_now: "Get started now",
  device_name_info: "You can change the device name of your mobile device to keep track of multiple devices. Example: \"Smartphone MaxMustermann\". The name can also be changed at a later time.",
  select_project: "Select Project",
  select_time: "Select time",
  create_new_account: "Create New Account",
  join_my_company: "Join my company",
  join_clockin_with_qr: "Join with QR code",
  change_project: "Switch Project",
  my_messages: "My Messages",
  my_documents: "My documents",
  my_data_and_passwords: "My Data & Passwords",
  my_account_data: "My Data",
  change_my_password: "Change Password",
  forgot_password: "I do not know my password.",
  open_camera: "Open Camera",
  scan_now: "Scan now",
  sync_now: "Sync now",
  clear_logs: "Clear Logs",
  saveAndGoBack: "Save and go back",
  full_day: "Full Day",
  activate_scanner: "Scanner will be activated",
  scanner_is_inactive: "Scanner inactive",
  change_project_by_scan_qr: "Scan the QR code of the project you want to switch to.",
  scan_device_by_qr: "Scan the QR code from the device you want to use.",
  no_access_to_camera_please_connect_device_manually: "Unfortunately, the camera could not be accessed, please enter the device code manually.",
  no_access_to_camera_please_clockin_manually: "Unfortunately, no access to the camera was possible, please clock in manually.",
  qr_code_login: "QR code registration",
  scan_to_login: "Scan your QR code to log in.",
  checklist_was_saved: "Checklist was saved",
  question_save_changes_short: "Save changes?",
  question_save_changes: "Do you want to save your changes?",
  question_delete_checklist_short: "Delete checklist?",
  question_delete_checklist: "Are you sure you want to delete the checklist?",
  checklist_is_sending: "Checklist will be sent",
  checklist_sent_successfully: "Checklist sent successfully 🎉",
  checklist_could_not_be_sent: "Checklist could not be sent, please try again later.",
  checklist_transmission_problems_in_the_past: "In the past, there have been transfer issues with some files.",
  checklist_send_with_potential_data_loss: "Would you like to try to send the checklist without these files?",
  documentation_is_sending: "Project documentation is sent",
  documentation_sent_successfully: "Project documentation successfully sent 🎉",
  confirm_documentation_dismissal: "Do you really want to discard the documentation?",
  discard_unsaved_changes: "Do you want to discard your changes?",
  documentation_will_be_sent_when_online: "The documentation will be sent as soon as you are online again.",
  confirmation_is_sending: "Project confirmation is sent",
  ask_for_geo_permission: "This app needs your location, " + "but lacks the permission to do so.\n\n" + "Do you want to open the settings?",
  all_projects: "All Projects",
  half_day: "Half Day",
  start_end: "By time",
  my_area: "My Area",
  my_area_video_teaser_clockin_explained_by_frederik: "clockin explained by Freddi",
  add_time: "Create time",
  show_times_in_confirmation: "Show times in confirmation",
  change_time: "Change Time",
  finish_project: "Complete project",
  finish_project_date: "Finalize appointment",
  unfinish_project: "Reopen project",
  unfinish_project_date: "Reopen appointment",
  absence_overview: "Manage Absences",
  edit_absence: "Edit Absence",
  edited_absence: "Edited Absence",
  created_absence: "Leave request successfully created",
  creating_absence: "Your leave request is now created",
  error_creating_absence: "Error when creating the absence request",
  create_absence: "Create Absence",
  deleted_absence: "Request for absence withdrawn",
  new_request: "New Request",
  your_requests: "Your Requests",
  planned_days: "Scheduled days",
  planned_hours: "Scheduled hours",
  used_days: "Days used",
  used_hours: "Hours Spent",
  free_days: "Days off",
  free_hours: "Vacation hours",
  open_days: "Open days",
  open_hours: "Open hours",
  withdraw_request: "Withdraw request",
  change_request: "Change request",
  request_was_approved: "Your request was approved",
  request_is_pending: "Your request has not been approved yet",
  request_was_rejected: "Your request was rejected",
  add_attachment: "Add Attachment",
  message_optional: "Message (optional)",
  filed_on: "Submitted on",
  this_year: "This year",
  search_sub_projects: "What sub-project do you want to work on?",
  error_occurred: "An error occurred, try again later.",
  re_record: "Delete and re-record this video?",
  delete_video: "Delete recording?",
  no_results_found: "No results found",
  record_again: "Retry",
  request_valid_email: "Please enter a valid email address.",
  request_valid_company_name: "Please enter a valid company name.",
  request_valid_first_name: "Please enter a valid first name.",
  request_valid_last_name: "Please enter a valid last name.",
  total_duration_today: "Total time today",
  show_daily_protocol: "Show daily log",
  change_profile_pic: "Change profile picture",
  logout_account: "Disconnect account",
  you_are_working: "You are working right now!",
  you_are_taking_a_break: "You are taking a break!",
  activity_edited: "Acitvity edited",
  activity_edited_undo: "Editing successfully undone",
  activity_edited_missing_project: "Oh, the project is still missing!",
  activity_deleted: "Activity deleted",
  activity_deleted_undo: "Deleted activity restored",
  activity_created: "New activity created",
  activity_created_undo: "Newly created activity withdrawn",
  correct_working_hours: "Correct working hours",
  your_changes_are_being_saved: "Your changes will now be saved.",
  manage_working_hours: "Manage working hours",
  delete_activity: "Delete activity",
  start_navigation: "Start navigation",
  no_valid_email: "The entered e-mail address is not valid.",
  delete_checklist: "Delete checklist",
  active_checklists: "Active checklists",
  scan_qr_code: "Scan QR code",
  switch_to_office_center: "Switch to the office center",
  confirm_project_completion_short: "Complete project",
  confirm_project_date_completion_short: "Finalize appointment",
  project_completed: "Project completed!",
  project_date_completed: "Appointment closed!",
  confirm_project_uncompletion_short: "Reopen project",
  confirm_project_date_uncompletion_short: "Reopen appointment",
  project_uncompleted: "Project activated",
  project_date_uncompleted: "Date activated",
  choose_project: "Select Project",
  choose_sub_project: "Select subproject",
  choose_site: "Select location",
  active_projects: "Active projects",
  completed_term: "completed",
  completed_projects: "Completed projects",
  end_of_work: "Have a great day",
  correct_time: "Correct time",
  you_stamp_x: "You clock in",
  enter_pin: "Please enter a PIN",
  wrong_pin: "incorrect PIN entry",
  pin_change_required: "You have been prompted to change your PIN",
  enter_new_pin: "Enter new PIN",
  approve_pin: "Confirm PIN",
  no_projects_scheduled: "For {day} no projects are stored.",
  you_clock_in_project: "You record project work time from now on.",
  project_scan_error: "This code is not valid for any project.",
  show_more_days: "show more days",
  show_more_times: "Show more times",
  only_show_today: "show today only",
  todays_total_time: "Total time today",
  everything_synced: "Your data is up to date!",
  upload_in_progress: "The data is uploaded...",
  who_are_you: "Who are you?",
  is_uploading_to_server: "Your changes are being transferred to the office center.",
  offline_and_data_is_stored_locally: "Your changes will soon be transferred to the office center. ",
  show_more: "show more",
  activity_edited_wrong_date: "You have entered an incorrect date.",
  confirm_logout: "Do you really want to log out?",
  confirm_clockout: "Are you sure you want to clock out for the day?",
  gps_is_active: "GPS data is transmitted",
  location_tracking_is_active: "To enable GPS tracking.",
  app_settings: "App settings",
  clock_reminder: "Stamp - Reminder",
  mon_to_fri: "Standard: Mondays - Fridays",
  logout: "Disconnect account",
  refresh: "Refresh",
  prompt_language_settings: "Set the language of the app here.",
  prompt_clock_reminder: "Reminder via push notification to match your everyday work.",
  register_company: "Register company",
  use_code: "Connect",
  our_customers: "Our customers",
  free_test_now: "Test now for free",
  tier_attendance: "I only record working hours and breaks.",
  tier_documentation: "I also want to post working hours on projects that I manage in clockin.",
  your_tier: "Your package",
  all_clockin_functions: "All clockin functions",
  checklists_formulars: "Checklists & Functions",
  projectfile_incl_chat: "Digital project files (incl. chat)",
  photo_sketch_note: "Photo, sketch & note function",
  digital_signature: "Digital signatures",
  datev_connection: "DATEV connection",
  calendar_absences: "Manage calendar & absences",
  individual_design: "Individual look",
  attendance_time_tracking: "Stationary time recording via tablet terminal",
  mobile_time_tracking: "Mobile time recording via smartphone app",
  browser_time_tracking: "Browser time recording on PC for home office",
  help_use_code: "Please enter the code you find in the office center under mobile devices/employees.",
  wrong_code: "Wrong code",
  wrong_code_text: "The code is not valid. Please try again with a valid code",
  wrong_code_text_short: "The code is invalid",
  clockin_logo: 'Clockin Logo',
  invalid_qr_code: "Invalid QR code",
  invalid_qr_code_text: "The scanned QR code is not valid. Please scan a valid clockin code.",
  code_already_connected: "With this code you can connect your device. But you are already connected.",
  wrong_credentials: "Incorrect access data",
  wrong_credentials_text: "The entered combination of email and password could not be found. Please check your input and try again.",
  new_pin: "Enter new PIN",
  choose_next_action: "Choose your next action",
  name_of_software_package: "Software package name",
  select_teamleader: "Who’s clocking in for the team?",
  select_teamleader_description: "To continue clocking activities, please select a person who will now take over the device.",
  clocked_in_on_this_device: "Clocked in on this device",
  not_clocked_in_on_this_device: "Not clocked in on this device",
  select_new_teamleader: "Who should continue clocking in for the team?",
  switch_teamleader: "Hand over device",
  just_me: "Only clock me out",
  select_the_new_teamleader: "Set the new team leader",
  back_to_selection: "back to the selection",
  manage_team: "Manage team",
  total_time_team: "Total time of the team",
  count_members_clocked_in: "{clockedin}/{members} Team members clocked in",
  whole_team: "Entire team",
  teammembers_still_clockedin: "Choose whether you want to clock out just you or everyone on the team?",
  clockout_all: "Clock everyone out",
  select_employee: "First select a user",
  something_went_wrong: "Something went wrong, please try again later.",
  new_pin_successfully_changed: "PIN successfully changed",
  enter_pin_before_clockin_prompt: "First, enter your PIN one at a time to clock in.",
  enter_pin_before_clockout_prompt: "First, enter your PIN one at a time to clock out.",
  delete_activity_alert_title: "Delete activity",
  delete_activity_alert_msg: "Are you sure you want to delete the activity?",
  delete_absence_message: "Are you sure you want to withdraw the application?",
  delete_absence_title: "Withdraw request",
  are_you_sure: "Are you sure?",
  request_password: "Request new password",
  password_requested: "A link for a new password was sent to your e-mail address",
  no_email_retrieved: "Did not receive mail? Please check your spam folder or try again.",
  name_of_customer: "Name of the customer",
  missing_permissions_homepage_text: "You do not have permission to change your activity on this device. Please contact your administrator to get access.",
  no_permission_warning_my_area: "You do not have the permission to access this area. Please contact your administrator to get access.",
  employee_clocked_in: "{name} registered!",
  employee_clocked_out: "{name} logged out!",
  no_employee_to_qr_code_warning: "No employee could be found for this QR code.",
  no_employees_registered_heading: "No employees have been assigned to this device yet.",
  no_employees_registered_body: "In the office center in the mobile device settings you can assign employees who are then allowed to record their times on this device.",
  no_employee_found: "Unfortunately, no one could be found with this name.",
  no_employee_assigned: "No employee assigned",
  you_need_help: "You need help?",
  here_you_can_get_help_to_register_employees_for_device: "Here you can find all the information on how to assign employees to a device.",
  show_time: "Create time",
  export_timesheet: "Export timesheet",
  select_month: "Select month",
  internet_connection_required: "An Internet connection is required for this.",
  select_an_activity_to_clockin_your_team: "Select an activity to clock in your team.",
  confirm_uploading_sqlite_for_debugging: "Are you sure you want to upload the data in the app for Clockin support?",
  no_tasks_available: "No tasks available",
  click_to_add_tasks: "Click to add tasks",
  scan_nfc_tag: "Please hold your card up to the reader.",
  link_nfc_tag: "Link NFC tag",
  select_employee_for_nfc_tag: "Please select an employee to link this NFC tag:",
  nfc_tag_linked_successfully: "NFC tag successfully with {name} linked.",
  nfc_linking_failed: "NFC tag could not be linked. Please try again.",
  nfc_not_enabled: "NFC is not supported by this device or is disabled.",
  nfc_initialization_failed: "Unfortunately, something went wrong. Please try again.",
  nfc_scan_failed: "Unfortunately, something went wrong. Please try again.",
  nfc_no_tag_found: "No NFC tag was found.",
  nfc_tag_already_linked_to: "This NFC tag is already available with {name} linked.",
  nfc_scan_active: "NFC scan active",
  nfc_linking_enabled: "NFC tags can now be linked. Please hold the NFC tag to be linked to the NFC reader now.",
  nfc_all_employees_linked: "All employees assigned to this device have already been linked.",
  no_employee_to_nfc_warning: "No employee could be found for this NFC tag.",
  select_employee_to_link_nfc: "Who should the NFC tag be linked to?",
  new_onboarding: {
    personal_app_manager: {
      heading: {
        welcome: "Welcome to clockin",
        clocking_time: "Track times",
        push_notifications: "Don't forget anything"
      },
      text: {
        clocking_time: "The clocker is your starting point for every activity. You take care of your work, the app does the documentation.",
        push_notifications: "Now turn on notifications. clockin reminds you if you forget a stamp and makes sure you get everything important right away."
      },
      button: {
        lets_go: "Get started now"
      }
    },
    my_area: {
      heading: {
        my_area: "My Area",
        absences: "Absences and requests",
        settings: "Personal settings"
      },
      text: {
        my_area: "The central place where you have an instant overview of your working hours and overtime. From here you can manage your working hours, access your daily log, submit requests and view your times.",
        absences: "Manage vacation requests, sick days and other absences. Always keep track of the status of your requests and submit new ones quickly and easily with just a few clicks.",
        settings: "Send messages in the company or change your personal settings and if you want to change your password, you can do that here too!"
      },
      button: {
        lets_go: "Get Started"
      }
    }
  },
  onboarding: {
    personal_app: {
      heading: {
        your_time_matters: "Because your time counts",
        clock_in: "Stamp in",
        switch_task: "Switch activity",
        clock_out: "Clock out",
        thats_it: "That's it!"
      },
      text: {
        your_time_matters: "With clockin we help you to concentrate on the essentials. Record your working time with just one click.",
        clock_in: "With one click you are directly clocked in. Clockin saves your data automatically and you have everything in view at any time.",
        switch_task: "Got another project, taking a break or heading to your next appointment? Just clock yourself into your new activity. The rest will be recorded automatically.",
        clock_out: "And with one click you are clocked out.",
        thats_it: "You've done it and are ready to record your working time. If you need help, just contact us. Everything is easy with clockin - including communicating with us."
      },
      button: {
        your_time_matters: "Show me how it's done",
        thats_it: "Get started now"
      }
    },
    team_app: {
      heading: {
        your_time_matters: "Because your time counts",
        clock_in: "Stamp in",
        clock_in_team: "Clock in team",
        switch_task: "Switch activity",
        change_teamleader: "Hand over device",
        clock_out: "Clock out",
        thats_it: "That's it!"
      },
      text: {
        your_time_matters: "With clockin we help you to concentrate on the essentials. Record the working time of your team with just one click.",
        clock_in: "Select a person who clocks in for the team and with one click you are clocked in directly. clockin saves your data automatically and you can keep track of everything at all times.",
        clock_in_team: "Simply clock in your team directly. Whether all at the same time or just individual members.",
        switch_task: "You have another project, are taking a break or are traveling to your next appointment? Simply change the stamp to your new activity. The rest will be recorded automatically.",
        change_teamleader: "You're getting off work, have to leave or are no longer clocking in for the team? Simply hand over the device in the app and everything goes back to normal.",
        clock_out: "And with one click, you and your team are clocked out. Of course, you can also clock out individual members at any time.",
        thats_it: "You've done it and are ready to record the working time for your team. If you need help, just contact us. Everything is easy with clockin - including communicating with us."
      },
      button: {
        your_time_matters: "Show me how it's done",
        thats_it: "Get started now"
      }
    },
    my_area: {
      heading: {
        welcome: "Welcome to your area",
        my_area: "My Area",
        create_time: "Create time",
        change_time: "Correct time",
        absences: "Absences and requests",
        settings: "Personal settings",
        thats_it: "That's it!"
      },
      text: {
        welcome: "Discover now even more ways to manage your working time efficiently and easily. Let's take a look at your area.",
        my_area: "The central place where you have an instant overview of your working hours and overtime. From here you can manage your working hours, access your daily log, submit requests and view your times.",
        create_time: "Forgot to enter a time or want to add times later? No problem! Add missing times, record breaks and keep your working time account up to date.",
        change_time: "Would you like to correct your times? No problem! With clockin you can easily correct and adjust incorrect times.",
        absences: "Manage vacation requests, sick days and other absences. Always keep track of the status of your requests and submit new ones quickly and easily with just a few clicks.",
        settings: "Send messages in the company or change your personal settings and if you want to change your password, you can do that here too!",
        thats_it: "You did it! Now you can effortlessly manage your time, organize absences and focus on what's important: your work. Good luck with your productive time!"
      },
      button: {
        welcome: "Show me how it's done",
        thats_it: "Get started now"
      }
    },
    clock: {
      clockin_now: "Lock in now",
      clock_your_first_time_now: "& record your first time"
    }
  },
  surveys: {
    nps: {
      thanks_for_using_clockin: "Thank you for using clockin!",
      question: "How likely is it that you will recommend clockin to friends or colleagues?",
      very_likely: "Very likely",
      very_unlikely: "Very unlikely",
      help_us_improve: "How can we improve clockin for you?",
      what_do_you_agree_with: "Which statements would you agree with?",
      choose_three_statements: "Choose up to three statements.",
      hard_to_use: "difficult to operate",
      lacking_features: "Too few functions",
      does_not_help_me: "does not make my working day any easier",
      confusing: "confusing",
      poorly_implemented: "Functions poorly implemented",
      too_buggy: "too error-prone",
      too_slow: "long loading times",
      what_else: "Is there anything else you would like to tell us?",
      can_we_ask_you_a_few_questions: "May we ask you a few more questions?",
      how_happy_are_you_with_the_introduction_of_clockin: "How happy are you with the introduction of clockin in your company?",
      how_much_do_you_enjoy_using_clockin: "How do you like using clockin?",
      how_much_easier_does_clockin_make_your_work: "How much does clockin make your daily work easier?",
      how_happy_are_you_with_the_following_aspects: "How satisfied are you with the following points?",
      clarity_of_the_app: "Clarity of the app",
      simplicity_of_use: "Simplicity of operation",
      app_features: "Functions in the app",
      feedback_received: "Your feedback has been received. Thank you for taking the time.",
      thanks_for_taking_the_time: "Thank you for taking the time.",
      what_can_we_do_to_improve: "Can you tell us more about your experience so that we can do even better next time?",
      what_can_we_do_to_get_it_right: "Can you tell us more about your experience so that we can get it right next time?",
      comment_placeholder: "Your message"
    }
  },
  travel_logs: {
    add: "Add journey details",
    edit: "Edit journey details",
    saving: "Journey details are saved...",
    saved_successfully: "Journey details successfully saved!",
    unable_to_save: "Unfortunately, that didn't work out 😢"
  },
  attach_file: "Attach file",
  image_to_text: {
    info: "Make sure that the text is clearly recognizable and can be seen in full on the image.",
    attach_image: "Attach picture",
    processing: "Your text will be read in.",
    processing_failed: "Unfortunately, the import did not work 😢",
    no_text_found: "No text could be recognized."
  },
  correction_enter_reason: "Please provide a reason for the correction.",
  daily_notes: {
    add: "Write a note",
    edit: "Edit note",
    saving: "Note is saved...",
    saved_successfully: "Note successfully saved!",
    unable_to_save: "Unfortunately, that didn't work out 😢",
    no_notes_yet: "No note created",
    create_note: "Create"
  },
  calendar_sync: {
    title: "Synchronize project schedule",
    description: "Synchronize your work schedule with a calendar and keep track of old and new appointments.",
    url: "Address in iCal format",
    url_description: "You can use this address to access this calendar from other applications.",
    note: "Note",
    note_description: "With some calendars, it can take up to 24 hours for new appointments to be displayed there.",
    sync_now: "Synchronize calendar",
    copied: "Calendar url copied."
  },
  registration: {
    skip_all: "Skip all",
    already_signed_up: "I already have an account",
    title_1: "Let's get started! Which times would you like to record with clockin?",
    description_1: "Let us customize clockin for you",
    option_1_a: "General working time (coming, going & break)",
    option_1_b: "Project working hours",
    title_2: "Would you like to document?",
    description_2: "What requirements must be met for this?",
    option_2_a: "Photos",
    option_2_b: "Sketches",
    option_2_c: "Note function",
    option_2_d: "Checklists & Forms",
    option_2_e: "Digital project files",
    title_3: "What else would you like to digitize?",
    description_3: "There is much more to discover at clockin, maybe there is something for you.",
    option_3_a: "Vacation",
    option_3_b: "Illnesses & absences",
    option_3_c: "Digital personnel file",
    option_3_d: "Company analysis",
    option_3_e: "Schedule",
    option_3_f: "Data transfer tax consultant (DATEV)",
    title_4: "In which industry is your company active?",
    description_4: "We want to get to know you better so that we can tailor clockin more to your needs.",
    option_4_a: "Services",
    option_4_b: "Craft",
    option_4_c: "Health and wellness",
    option_4_d: "Purchasing, ordering & trading",
    option_4_e: "Hotel and gastronomy",
    option_4_f: "Car, traffic & machines",
    option_4_g: "Other industry",
    title_5: "How many employees are part of your company?",
    description_5: "With the number of employees, we can tailor clockin to the size of your company.",
    title_6: "Super! Your clockin is now set up",
    description_6: "All we need is your name.",
    input_6_a: "Company",
    input_6_b: "First name",
    input_6_c: "Last name",
    input_6_d: "Phone number",
    title_7: "You're ready to go! Try clockin 14 days for free!",
    input_7_a: "Your e-mail address",
    description_7: "To which e-mail address should we send your password?",
    input_7_b: "That's how I became aware",
    how_did_you_hear_about_clockin: "How did you first hear about clockin?",
    recommendation_option_1: "Recommendation",
    recommendation_option_2: 'Facebook',
    recommendation_option_3: 'Instagram',
    recommendation_option_4: "Internet search",
    recommendation_option_5: 'LinkedIn',
    recommendation_option_6: "Comparison platform",
    recommendation_option_7: "Magazine & online articles",
    known_from: "Known from",
    agb_1: "By submitting the form, you accept the ",
    agb_2: "Terms and Conditions",
    agb_3: " and the ",
    agb_4: "Privacy policy",
    start: "Start test",
    validation_failed: "Please fill in all fields correctly."
  },
  clocki: {
    listening_heading: "I'm listening to you",
    listening_subtext: "how can I help you?",
    hi_0: "Hi, how can I help you?",
    hi_1: "Hey, how can I help you?",
    hi_2: "Hello, how can I help you?",
    hi_3: "Moin moin, what can I do for you?",
    hi_4: "Hi, what can I do for you?",
    hi_5: "Hello, how can I help you?",
    // hi_1: 'Hi {name}​, sag mir, wie kann ich dir helfen?',
    // hi_2: 'Hi {name}​, wie kann ich dir helfen?',
    // hi_3: 'Hi {name}​, was kann ich für dich tun?',
    // hi_4: 'Moin {name}​, was kann ich für dich tun?',
    // hi_5: 'Hallo {name}​, wie kann ich dir helfen?',
    // hi_6: 'Grüß dich {name}​, wobei kann ich dich unterstützen?',
    // hi_7: 'Guten Tag {name}​, womit kann ich dir heute helfen?',
    speech_recognition_unavailable: "Unfortunately, voice recognition does not seem to work on your device",
    microphone_permission_denied: "Unfortunately, I don't have access to your microphone. Please check the permissions in the settings so that I can hear you.",
    please_speak: "You can now talk to Clocki",
    create_activity: "Create an activity",
    modify_activity: "Change Activity",
    delete_activity: "Delete activity",
    create_daily_note: "Create a daily note",
    search_project: "Search for a project",
    note_copied: "Note copied",
    create_absence_request: "Request absence",
    delete_absence: "Delete absence",
    confirm_deletion: "Are you sure that your {activity_label} Stamping from {date} clock should be deleted?",
    confirm_absence_deletion: "Are you sure that your request for {category} from the {startDate} until {endDate} want to delete?",
    task_before_modification: "Before: {task}",
    starts_at_before_modification: "Start time before: {startsAt}",
    ends_at_before_modification: "End time before: {endsAt}",
    something_went_wrong: "Oh, something went wrong, please try again later.",
    was_this_helpful: "Could Clocki help you?",
    actions: {
      CREATE_ABSENCE: {
        title: "Confirm absence"
      },
      CREATE_DAILY_NOTE: {
        title: "Create a note now",
        daily_notes_disabled: "Unfortunately, the note function is deactivated. Please ask your administrator to activate the function in the Office Center.",
        success: "Note successfully saved in the daily log 🎉"
      },
      CREATE_PROJECT_NOTE: {
        title: "Create documentation now",
        created_by_clocki: "Created with Clocki"
      },
      REDIRECT_TO_CORRECT_TIMES: {
        title: "Open \"My times\" now"
      },
      REDIRECT_TO_MY_AREA: {
        title: "Open \"My area\" now"
      },
      REDIRECT_TO_CHANGE_PASSWORD: {
        title: "Open \"Change password\" now"
      },
      CHANGE_ACTIVITY: {
        WORKING_TIME: "Stamp \"working time\" now",
        PAUSE: "Stamp \"Pause\" now",
        DRIVING_TIME: "Stamp \"travel time\" now",
        LOGOUT: "Unlock now"
      }
    }
  },
  review_prompt: {
    do_you_like_clockin: "Do you like using Clockin?"
  },
  translation_failed: "Unfortunately, the translation did not work 😕",
  video_transcript_not_available: "No transcript available",
  video_upload_succeeded: "Video upload completed.",
  video_upload_failed: "Video upload failed.",
  video_send_failed: "The video could not be broadcast at the moment. We'll try again later.",
  uploading_video: "Uploading video...",
  language_selection_header: "Select language",
  language_selection_message: "Choose your preferred language",
  shifts: {
    my_shifts: "My Shifts",
    free_shifts: "Free shifts",
    next_shift: "Your next shift",
    shift_not_found: "No layers found",
    show_shift_plan: "View this shift schedule",
    no_shift_place: "No location specified",
    no_shifts_assigned: "You are currently not assigned to any shift",
    free_shifts_unavailable: "Free shifts are currently not available",
    filter_shift_plans: "Filter Shift Schedules",
    no_shift_plans_available: "No shift schedules available",
    filter_locations: "Filter places",
    no_locations_available: "No places available",
    no_plan_selected: "No shift schedule selected",
    no_shifts_for_plan: "No layers found for this plan",
    no_shifts_for_location: "No shifts found for the selected location",
    unknown_shift_plan: "Unknown shift schedule",
    unknown_location: "Unknown location",
    loading_more_shifts: "Load more layers..."
  },
  clockin_reminder_title: "Already at work? 🔔",
  clockin_reminder: "Remember to clock in.",
  clockout_reminder_title: "Are you already at the end of the day? 🔔",
  clockout_reminder: "Don't forget to clock out.",
  choose_clockin_reminder_time: "Clock-in reminder time",
  choose_clockout_reminder_time: "Clock-out reminder time",
  choose_break_reminder_time: "Pause Length",
  saved_successfully: "Successfully saved 👍",
  clock_reminder_channel_name: "Stamp Reminders",
  clock_reminder_channel_description: "Reminders to clock in and out",
  break_reminder_title: "Are you still taking a break? ⏰",
  break_reminder: "Note: Your break time is still running.",
  // Video component translations
  video_not_supported: "Your device does not support the video :/",
  video_loading_error: "Error loading video",
  video_retry: "Reload"
};